import { render, staticRenderFns } from "./global-loading.vue?vue&type=template&id=51099196&"
import script from "./global-loading.vue?vue&type=script&lang=js&"
export * from "./global-loading.vue?vue&type=script&lang=js&"
import style0 from "./global-loading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports